import './footer.css';
import logo_stb from '../img/logo-stb.png';
import logo_x_white from '../img/logo-x-white.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img src={logo_stb} alt="logo-Science_Tokyo_Biz" className="icon-footer" />
        <nav className="footer-nav">
          <a href='https://x.com/IST_biz'>
            <img src={logo_x_white} alt="icon-section" className='icon-section' />
          </a>
          <span className="footer-divider"></span>
          <a href="#vision">Vision</a>
          <a href="#events">Events</a>
          <a href="#interviews">Interview</a>
          <a href="#partners">Partners</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
      <p className="footer-copy">&copy; 2025 Science Tokyo Biz. All rights reserved.</p>
    </footer>
  );
}

export default Footer;